/**
 * FHIR Subgraph Widgets — Dashboard widgets for clinical data (DRR-321)
 *
 * These widgets display FHIR resources in the subject dashboard.
 * Each widget self-registers with the widget registry on import.
 */

import { registerWidget } from '@ferp/core';

// Widget components
import { FhirCarePlanWidget } from './FhirCarePlanWidget';
import { FhirMedicationListWidget } from './FhirMedicationListWidget';
import { FhirConditionListWidget } from './FhirConditionListWidget';
import { FhirAllergyListWidget } from './FhirAllergyListWidget';
import { FhirVitalsChartWidget } from './FhirVitalsChartWidget';
import { SbarFormWidget } from './SbarFormWidget';
import { LoaTrackerWidget } from './LoaTrackerWidget';

// Register FHIR widgets
registerWidget({
  componentHint: 'fhir-care-plan',
  component: FhirCarePlanWidget,
  package: 'fhir',
  label: 'Care Plans',
  category: 'clinical',
});

registerWidget({
  componentHint: 'fhir-medication-list',
  component: FhirMedicationListWidget,
  package: 'fhir',
  label: 'Medications',
  category: 'clinical',
});

registerWidget({
  componentHint: 'fhir-condition-list',
  component: FhirConditionListWidget,
  package: 'fhir',
  label: 'Conditions',
  category: 'clinical',
});

registerWidget({
  componentHint: 'fhir-allergy-list',
  component: FhirAllergyListWidget,
  package: 'fhir',
  label: 'Allergies',
  category: 'clinical',
});

registerWidget({
  componentHint: 'fhir-vitals-chart',
  component: FhirVitalsChartWidget,
  package: 'fhir',
  label: 'Vitals Chart',
  category: 'clinical',
});

registerWidget({
  componentHint: 'sbar-form',
  component: SbarFormWidget,
  package: 'fhir',
  label: 'SBAR Communication',
  category: 'communication',
});

registerWidget({
  componentHint: 'loa-tracker',
  component: LoaTrackerWidget,
  package: 'fhir',
  label: 'Leave of Absence',
  category: 'operational',
});

// Re-export widgets for direct import
export { FhirCarePlanWidget } from './FhirCarePlanWidget';
export { FhirMedicationListWidget } from './FhirMedicationListWidget';
export { FhirConditionListWidget } from './FhirConditionListWidget';
export { FhirAllergyListWidget } from './FhirAllergyListWidget';
export { FhirVitalsChartWidget } from './FhirVitalsChartWidget';
export { SbarFormWidget } from './SbarFormWidget';
export { LoaTrackerWidget } from './LoaTrackerWidget';

// Log registration for debugging
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  console.log('[WidgetRegistry] FHIR widgets registered: 7');
}
